import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "page-content" }

import { ref, onMounted } from 'vue';
import Nav from '@/components/Nav.vue';
import Footer from '@/components/Footer.vue';
import { RouterView } from 'vue-router';
import { ModalsContainer } from 'vue-final-modal';
import { getAuth, onAuthStateChanged } from 'firebase/auth';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const user = ref(null);
const auth = getAuth();

onMounted(() => {
  onAuthStateChanged(auth, (currentUser) => {
    user.value = currentUser;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (user.value)
      ? (_openBlock(), _createBlock(Nav, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_unref(RouterView))
    ]),
    _createVNode(_unref(ModalsContainer)),
    _createVNode(Footer)
  ]))
}
}

})